/** GST rate on trek prices (website prices are GST-inclusive). */
const GST_RATE = 0.05;
const HALF_GST_RATE = 0.025;

/**
 * Trek prices on the website include 5% GST (2.5% SGST + 2.5% CGST).
 * From an inclusive amount: derive taxable value, then apply 2.5% + 2.5% on that base.
 *
 * @returns {{ subTotal: number, sgst: number, cgst: number, gstTotal: number, grandTotal: number }}
 */
export function gstInclusiveBreakdown(inclusiveAmount) {
  const grandTotal = Math.round((Number(inclusiveAmount) || 0) * 100) / 100;
  if (grandTotal <= 0) {
    return { subTotal: 0, sgst: 0, cgst: 0, gstTotal: 0, grandTotal: 0 };
  }

  // Remove embedded 5% GST — taxable = inclusive ÷ 1.05 (not inclusive × 0.95).
  const subTotal = Math.round((grandTotal * 100) / (100 + GST_RATE * 100));
  let sgst = Math.round(subTotal * HALF_GST_RATE);
  let cgst = Math.round(subTotal * HALF_GST_RATE);
  let gstTotal = sgst + cgst;

  // Penny reconciliation so taxable + SGST + CGST equals the inclusive trek price.
  const diff = grandTotal - (subTotal + sgst + cgst);
  if (diff !== 0) {
    cgst += diff;
    gstTotal = sgst + cgst;
  }

  return { subTotal, sgst, cgst, gstTotal, grandTotal };
}

/** Receipt print: whole rupees when possible (no trailing .00). */
export function formatReceiptInr(value) {
  const n = Number(value) || 0;
  if (Number.isInteger(n) || Math.abs(n - Math.round(n)) < 0.001) {
    return Math.round(n).toLocaleString('en-IN');
  }
  return n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
